(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["book-appointment-services"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    const cards = document.querySelectorAll(".service-card");
    const popups = document.querySelectorAll(".popup-overlay");

    cards.forEach(card => {
      card.addEventListener("click", function() {
        let calendlyUrl = this.getAttribute("data-calendly-url");
        if (calendlyUrl) {
          window.open(calendlyUrl, "_blank"); // open Calendly in new tab
        } else {
          let popupId = this.getAttribute("data-popup-id");
          document.getElementById(popupId).style.display = "flex";
        }
      });
    });

    document.querySelectorAll(".popup-close").forEach(btn => {
      btn.addEventListener("click", function() {
        this.closest(".popup-overlay").style.display = "none";
      });
    });

    popups.forEach(popup => {
      popup.addEventListener("click", function(e) {
        if (e.target === popup) {
          popup.style.display = "none";
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
